import React from 'react'

import {
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableFooter,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Copy
} from 'components'
import { DeleteIcon, EditIcon } from 'components/Icons'
import { Link } from 'components/Link/Link'
import { useLoading, useModal } from 'hooks'
import {
  IDocumentoCaixaResponseDto,
  DocumentoCaixaServices
} from 'services/NGT/Files'
import { COLORS, SPACING, FORMAT } from 'utils'
import { HandleCompetencia } from 'utils/functions'

interface ITableRegisterDocumentation {
  page: number
  setPage: (page: number) => void
  rowsPerPage: number
  rowsSize: number
  setRowsPerPage: (page: number) => void
  selectedContractInfo: (contractId: number) => void
  tableData: IDocumentoCaixaResponseDto[]
  handleSetDocumentoCaixas: () => void
  handleEdit: (_document: IDocumentoCaixaResponseDto) => void
}

const TableRegisterDocumentation: React.FC<ITableRegisterDocumentation> = ({
  tableData,
  handleSetDocumentoCaixas,
  page,
  rowsSize,
  rowsPerPage,
  selectedContractInfo,
  setRowsPerPage,
  setPage,
  handleEdit
}) => {
  const { setLoading } = useLoading()
  const { showModal } = useModal()

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value))
    setPage(1)
  }

  const handleDeleteDocumentoCaixa = (idDocumentoCaixa: number) => {
    setLoading('loading')

    DocumentoCaixaServices()
      .del(idDocumentoCaixa)
      .then((response) => {
        if (response.status === 200) {
          showModal({
            hideButtonCancel: true,
            message: 'Deletado com sucesso!',
            txtButtonConfirm: 'OK',
            type: 'success'
          })
          handleSetDocumentoCaixas()
        }
      })
      .catch((err) => {
        showModal({
          hideButtonCancel: true,
          message: err,
          type: 'error'
        })
        setLoading('error')
      })
      .finally(() => {
        setLoading('idle')
      })
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled></TableCellStyled>
              <TableCellStyled align="left">Contrato</TableCellStyled>
              <TableCellStyled align="left">Empresa</TableCellStyled>
              <TableCellStyled align="left">Centro</TableCellStyled>
              <TableCellStyled align="left">
                CPF/CNPJ/Cód.Fornecedor
              </TableCellStyled>
              <TableCellStyled align="left">Fornecedor</TableCellStyled>
              <TableCellStyled align="left">Competência</TableCellStyled>
              <TableCellStyled align="left">Caixa Externo</TableCellStyled>
              <TableCellStyled align="left">
                Caixa Departamental
              </TableCellStyled>
              <TableCellStyled align="left">Ações</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData.map((row) => (
              <TableRowStyled key={row.idDocumentoCaixa}>
                <TableCellStyled align="left">
                  <Copy
                    valueToCopy={row.codigoContrato}
                    title="Copiar código de contrato"
                  />
                </TableCellStyled>
                <TableCellStyled align="left">
                  <Link
                    onClick={() => selectedContractInfo(row.idContrato)}
                    color={COLORS.blueFonts}
                  >
                    {row.codigoContrato || '- - - -'}
                  </Link>
                </TableCellStyled>
                <TableCellStyled align="left">
                  {row.nmEmpresa || '- - - -'}
                </TableCellStyled>
                <TableCellStyled align="left">
                  {row.nmCentroPlanta || '- - - -'}
                </TableCellStyled>
                <TableCellStyled align="left">
                  {FORMAT.formatCdDocto(row.cnpj)}
                </TableCellStyled>
                <TableCellStyled align="left">
                  {row.fornecedor || '- - - -'}
                </TableCellStyled>
                <TableCellStyled align="left">
                  {HandleCompetencia(row.competencia) || '- - - -'}
                </TableCellStyled>
                <TableCellStyled align="left">
                  {row.isCaixaExterno ? row.nuCaixa : '- - -'}
                </TableCellStyled>
                <TableCellStyled align="left">
                  {!row.isCaixaExterno ? row.nuCaixa : '- - -'}
                </TableCellStyled>
                <TableCellStyled align="center">
                  <EditIcon
                    onClick={() => handleEdit(row)}
                    cursor="pointer"
                    marginRight={SPACING.spacing10}
                  />
                  <DeleteIcon
                    onClick={() =>
                      showModal({
                        handleConfirm: () =>
                          handleDeleteDocumentoCaixa(row.idDocumentoCaixa),
                        message: 'Confirma exclusão (S/N)?',
                        txtButtonCancel: 'NÃO',
                        txtButtonConfirm: 'SIM',
                        type: 'alert'
                      })
                    }
                    cursor="pointer"
                  />
                </TableCellStyled>
              </TableRowStyled>
            ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={tableData}
        totalItems={rowsSize}
        rowsPerPage={rowsPerPage}
        handleChangePage={(pageNumber) => setPage(pageNumber)}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  )
}

export default TableRegisterDocumentation
